import { CONSTRUCT } from 'constants/store.constants';
import { STATUS_INIT } from 'constants/statuses.constants';

const selectConstructSlice = (state) => state[CONSTRUCT];
export const selectConstruct = (state) => selectConstructSlice(state).construct;
export const selectConstructStatus = (state) => selectConstructSlice(state).status;
export const selectFetched = (state) => selectConstructStatus(state) !== STATUS_INIT;
